import AbstractDevice from '../all/AbstractDevice';
import ZeasnId from "./Id";
import ZeasnPlayer from "./Player";
import ZeasnPlayerUtil from "./PlayerUtil";
import ZeasnConfig from "./config";
import ZeasnKeys from "./Keys";
import ZeasnNetworkStatus from "./NetworkStatus";
import ZeasnSystem from "./System";

class ZeasnDevice extends AbstractDevice {
  constructor () {
    super(
      "zeasn",
      new ZeasnId(),
      new ZeasnPlayer(),
      new ZeasnPlayerUtil(),
      ZeasnConfig,
      new ZeasnKeys(),
      new ZeasnNetworkStatus(),
      new ZeasnSystem()
    );
  }
}

export default ZeasnDevice;



// WEBPACK FOOTER //
// ./src/devices/zeasn/Device.js